import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function Switch({
  className,
  isChecked,
  isDisabled = false,
  name = '',
  value = '',
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <div className={classNames('app-switch', className)}>
      <input
        checked={isChecked}
        className='tw-peer'
        name={name}
        readOnly={true}
        type='checkbox'
        value={value}
      />
      <label
        className={classNames(
          "tw-bg-grey-200 tw-text-grey-700 after:tw-bg-white after:tw-content-[''] hover:tw-bg-blue-050 group-hover/option:tw-bg-blue-050 peer-checked:tw-bg-blue-400 peer-checked:tw-text-white peer-checked:hover:tw-bg-blue-500 group-hover/option:peer-checked:tw-bg-blue-500",
          isDisabled && 'tw-cursor-not-allowed',
        )}
        data-switch-off={i18nTShared('no')}
        data-switch-on={i18nTShared('yes')}
      />
    </div>
  );
}

Switch.propTypes = {
  className: PropTypes.string,
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
};
